(function ($) {

    /*------------------------------------*\
        DEVHUB TABS
        Tab nav inside .js-devhub-tabs.
        Buttons: .devhub-tabs__tab[data-tab]
        Panels:  .devhub-tabs__panel[data-panel]
        Active state uses .is-active on both tab and panel.
    \*------------------------------------*/

    $.fn.devhubTabs = function () {

        var init = function () {

            $(document).on('click', '.js-devhub-tabs .devhub-tabs__tab', function () {

                var $tab      = $(this);
                var $tabs     = $tab.closest('.js-devhub-tabs');
                var targetKey = $tab.data('tab');

                $tabs.find('.devhub-tabs__tab').removeClass('is-active');
                $tab.addClass('is-active');

                $tabs.find('.devhub-tabs__panel').removeClass('is-active');
                $tabs.find('.devhub-tabs__panel[data-panel="' + targetKey + '"]').addClass('is-active');

            });

        };

        init();

        return this;

    };

}(jQuery));
